import { motion } from 'framer-motion';
import { styles } from '../styles';
import { staggerContainer } from '../utils/motion';

const SectionWrapper = (Component, idName) =>
	function HOC() {
		return (
			<motion.section
				variants={staggerContainer()}
				initial="hidden"
				whileInView="show"
				viewport={{ once: true, amount: 0.1 }}
				className={`${styles.paddingX} ${styles.paddingY} w-full relative z-0`}>
				<div className="max-w-6xl mx-auto">
					<span className="hash-span" id={idName}></span>
					<Component />
				</div>
			</motion.section>
		);
	};

export default SectionWrapper;
